export var config = {
  url:'http://13.232.20.58:7000',
}


// WEBPACK FOOTER //
// ./src/app/config/config.ts